import { render, staticRenderFns } from "./AutomaticAnswers.vue?vue&type=template&id=a62675ae&scoped=true&lang=pug"
import script from "./AutomaticAnswers.vue?vue&type=script&lang=js"
export * from "./AutomaticAnswers.vue?vue&type=script&lang=js"
import style0 from "./AutomaticAnswers.vue?vue&type=style&index=0&id=a62675ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62675ae",
  null
  
)

export default component.exports